import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router";

/**
 * FeaturedVideosSection
 * - Uses thumbnails + links (fast load; no embeds on homepage)
 * - Replace video URLs + thumbnail URLs with your real ones
 */
export default function FeaturedVideosSection() {
const videos = [
  {
    title: "If I Started Investing Today… I'd Buy THIS Portfolio!",
    blurb:
      "A beginner-friendly portfolio breakdown with simple roles for each position.",
    href:
      "https://www.youtube.com/watch?v=AodVyU2HxZE&utm_source=website&utm_medium=homepage&utm_campaign=featured_videos",
    thumbnail: "https://img.youtube.com/vi/AodVyU2HxZE/hqdefault.jpg",
  },
  {
    title: "If You Have Kids, You Should Be Investing Like This!",
    blurb:
      "A simple long-term approach for parents—plus how to think about ETFs and staying consistent.",
    href:
      "https://www.youtube.com/watch?v=BDgpAC_yoU4&utm_source=website&utm_medium=homepage&utm_campaign=featured_videos",
    thumbnail: "https://img.youtube.com/vi/BDgpAC_yoU4/hqdefault.jpg",
  },
  {
    title: "Core and Satellite Investing Strategy",
    blurb:
      "A clean strategy to build a strong core portfolio and add smaller positions without overcomplicating it.",
    href:
      "https://www.youtube.com/watch?v=EXCG2KQTEVU&utm_source=website&utm_medium=homepage&utm_campaign=featured_videos",
    thumbnail: "https://img.youtube.com/vi/EXCG2KQTEVU/hqdefault.jpg",
  },
];


  return (
    <div className="mt-5 mb-5">
      <Container>
        <div style={{ textAlign: "center" }} className="p-2 mb-4">
          <h2 className="mb-2">Start Learning Investing — For Free</h2>
          <p className="text-muted" style={{ maxWidth: 820, margin: "0 auto" }}>
            I’m not a financial advisor — I’m just documenting what I’m learning
            about investing and sharing it in a beginner-friendly way. If you’re
            new to stocks, ETFs, or building your first portfolio, start here.
          </p>
        </div>

        <Row className="g-3">
          {videos.map((v) => (
            <Col key={v.title} xs={12} md={4}>
              <Card className="h-100 shadow-sm" style={{ borderRadius: 12 }}>
                <div style={{ position: "relative" }}>
                  <Card.Img
                    variant="top"
                    src={v.thumbnail}
                    alt={v.title}
                    style={{
                      height: 180,
                      objectFit: "cover",
                      borderTopLeftRadius: 12,
                      borderTopRightRadius: 12,
                    }}
                    loading="lazy"
                  />
                </div>

                <Card.Body className="d-flex flex-column">
                  <Card.Title style={{ fontSize: "1.05rem" }}>
                    {v.title}
                  </Card.Title>
                  <Card.Text className="text-muted" style={{ fontSize: ".95rem" }}>
                    {v.blurb}
                  </Card.Text>

                  <div className="mt-auto d-flex gap-2">
                    <Button
                      as="a"
                      href={v.href}
                      target="_blank"
                      rel="noreferrer"
                      variant="outline-primary"
                    >
                      Watch on YouTube →
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <div style={{ textAlign: "center", maxWidth: "850px", margin: "auto auto" }} className="mt-4">
          <h3 className="mb-2">
            Not sure what to invest in? 
          </h3>
          <p>Take the free AI Portfolio Quiz and get a
            beginner-friendly portfolio built for you.</p>
          <Link to="/quiz">
            <Button>Build My Portfolio</Button>
          </Link>
        </div>
      </Container>
    </div>
  );
}
